import * as React from 'react'
import type { SVGProps } from 'react'
const SvgLightning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={22}
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.53979 12.6315L8.52895 1.64854C8.79751 1.22652 9.45078 1.41675 9.45078 1.91698V9.69995C9.45078 9.75518 9.49555 9.79995 9.55078 9.79995H14.4905C14.895 9.79995 15.132 10.2553 14.9001 10.5867L7.9604 20.5005C7.68006 20.901 7.05078 20.7026 7.05078 20.2138V13.5C7.05078 13.4447 7.00601 13.4 6.95078 13.4H1.96162C1.56707 13.4 1.32797 12.9644 1.53979 12.6315Z"
      stroke="#4F5277"
      strokeWidth={2}
    />
  </svg>
)
export default SvgLightning
